"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = List;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
function List(props) {
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: props.style, children: [(props.data == null || props.data?.length == 0) &&
                (props.listEmpty ? props.listEmpty() : null), (props.data != null && props.data?.length > 0) &&
                props.data.map((item, index, array) => (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [props.renderItem(item, index), (index < array.length - 1) &&
                            (props.itemSeparator ? props.itemSeparator(item) : null)] }, props.keyExtractor(item, index)))] }));
}
;
